import React from "react";
import NavBar from "../navBar/NavBar";
import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import Notification from "../../../components/UI/Notification";

const BaseLayout = () => {
  const notification = useSelector((state) => state.ui.notification);
  const isValid = true;

  return (
    <>
      {!isValid && <Outlet />}
      <div>
        {isValid && (
          <>
            <NavBar />
            <Outlet></Outlet>
            {notification && (
              <Notification
                status={notification.status}
                title={notification.title}
                message={notification.message}
                
              />
            )}
          </>
        )}
      </div>
    </>
  );
};
export default BaseLayout;
